import { getApiUrl, AXIOS_AUTHED } from './shared';

const LINE_ITEMS_BASE_URL = `${getApiUrl()}/renewal-line-items`;

const get = (lineItemId) => {
  return AXIOS_AUTHED.get(`${LINE_ITEMS_BASE_URL}/${lineItemId}`);
};

const update = (lineItem) => {
  return AXIOS_AUTHED.put(
    `${LINE_ITEMS_BASE_URL}/${lineItem.lineItemId}`,
    lineItem
  );
};

export { get, update };
